import React from "react";
import { Outlet, useParams } from "react-router-dom";
import {
  LayoutDashboard, FlaskConical, Activity, CalendarDays, Wrench, TrendingUp, Bell,
} from "lucide-react";
import { useDevice } from "@/hooks/useDevice";
import { PageHeader, Tabs, DeviceStatusBadge, type TabItem } from "@/components/ui";

// Tabbed device detail shell. Each tab is an existing device page nested under
// /devices/:deviceId/* (they read deviceId from useParams), consolidating what
// used to be scattered top-level routes + a separate sidebar sub-nav.
export function DeviceLayout() {
  const { deviceId = "" } = useParams();
  const { data: device } = useDevice(deviceId);

  const base = `/devices/${deviceId}`;
  const config = (device?.config ?? {}) as { has_sensors?: boolean };
  const hasSensors = config.has_sensors !== false;

  const tabs: TabItem[] = [
    { to: `${base}/overview`, label: "Overview", icon: LayoutDashboard },
    { to: `${base}/results`, label: "Results", icon: FlaskConical },
    ...(hasSensors ? [{ to: `${base}/summary`, label: "Sensors", icon: Activity }] : []),
    { to: `${base}/trends`, label: "Trends", icon: TrendingUp },
    { to: `${base}/health`, label: "Health", icon: Wrench },
    { to: `${base}/schedule`, label: "Schedule", icon: CalendarDays },
    { to: `${base}/alerts`, label: "Alerts", icon: Bell },
  ];

  return (
    <div>
      <PageHeader
        title={device?.label ?? device?.serial_number ?? "Device"}
        subtitle={device ? device.model : undefined}
        breadcrumbs={[{ label: "Devices", to: "/devices" }, { label: device?.label ?? device?.serial_number ?? "…" }]}
        actions={device ? <DeviceStatusBadge online={device.is_online} /> : undefined}
      />
      <Tabs tabs={tabs} />
      <Outlet />
    </div>
  );
}

export default DeviceLayout;
